import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadList: -1,
  },
  list: [],
  query: {
    search: '',
    clinic: -1,
    page: 1,
    pageSize: 15,
    totalPages: 1,
  },
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.EMR_PATIENTS_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 0,
        },
      };
    case ACTION_TYPES.EMR_PATIENTS_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 1,
        },
        list: payload.patientList,
        query: {
          ...state.query,
          totalPages: Math.ceil(payload.totalCount / state.query.pageSize),
        },
      };
    case ACTION_TYPES.EMR_PATIENTS_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 2,
        },
        error,
      };
    case ACTION_TYPES.EMR_CLINIC_CHANGE:
      return {
        ...state,
        query: {
          ...state.query,
          clinic: payload,
          page: 1,
        },
      };
    case ACTION_TYPES.EMR_PATIENT_PAGE_CHANGE:
      return {
        ...state,
        query: {
          ...state.query,
          page: payload,
        },
      };
    case ACTION_TYPES.EMR_PATIENT_SEARCH_CHANGE:
      return {
        ...state,
        query: {
          ...state.query,
          search: payload,
          page: 1,
        },
      };
    default:
      return state;
  }
}
